document.addEventListener("DOMContentLoaded", function () {
  const titles = document.querySelectorAll(".sidebar-category-container");

  // Mobile breakpoint
  const isMobile = window.matchMedia("(max-width: 768px)").matches;

  // --- Helper functions ---
  function closeCategory(category) {
    const content = category.querySelector(".sidebar-category-content");
    const icon = category.querySelector(".chevron-icon");

    category.classList.remove("active");
    if (content) content.style.maxHeight = null;
    if (icon) {
      icon.classList.remove("fa-chevron-up");
      icon.classList.add("fa-chevron-down");
    }
  }

  function openCategory(category) {
    const content = category.querySelector(".sidebar-category-content");
    const icon = category.querySelector(".chevron-icon");

    category.classList.add("active");
    if (content) content.style.maxHeight = content.scrollHeight + "px";
    if (icon) {
      icon.classList.remove("fa-chevron-down");
      icon.classList.add("fa-chevron-up");
    }
  }

  // --- INITIAL STATES ---
  titles.forEach((title) => {
    const header = title.querySelector(".sidebar-category");
    const content = title.querySelector(".sidebar-category-content");
    if (!header || !content) return;

    if (isMobile) {
      // Mobile → start closed
      closeCategory(title);
    } else {
      // Desktop → start open
      openCategory(title);
    }

    // --- CLICK HANDLER ---
    header.addEventListener("click", function (e) {
      if (e.target.tagName.toLowerCase() === "a") return;

      const isActive = title.classList.contains("active");

      if (isMobile) {
        // --- MOBILE → ONLY ONE OPEN AT A TIME ---
        titles.forEach(closeCategory);

        if (!isActive) {
          openCategory(title);
        }

      } else {
        // --- DESKTOP → NORMAL TOGGLE (NO one-at-a-time) ---
        if (isActive) {
          closeCategory(title);
        } else {
          openCategory(title);
        }
      }
    });
  });
});
